import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceBillingApi } from "@/services/billing/index";
import { BillingOrderItemType } from "@/schemas/index";

const LayoutPageOrderView = lazy(() => import("./layout/index"));

const loaderDataOrderView = async (args: any) => {
  try {
    const { orderId } = args.params;

    if (!orderId) {
      throw new Error("ORDER_ID_REQUIRED");
    }

    const order = serviceBillingApi.fetchBillingOrderById(orderId);

    if (!order) {
      throw new Error("ORDER_NOT_FOUND");
    }

    return order;
  } catch (err) {
    console.log(err);
  }
};

export const routerPageOrderView: RouterItemType = {
  path: "/billing/orders/:orderId",
  authorize: true,
  element: <LayoutPageOrderView />,
  loader: loaderDataOrderView,
};

export type RouterDataType = BillingOrderItemType;
